// extracted by mini-css-extract-plugin
module.exports = {"detail":"Detail_style_detail__153_j","footer":"Detail_style_footer__3CS6q"};